/*
 * Fades the header background in while the page is scrolled over a banner that has
 * "Show banner behind the header" ticked. Fully transparent at the top of the page, fully
 * solid once the page has been scrolled by a third of the banner's height.
 */
(function () {
  if (window.__headerOverBanner) {
    window.removeEventListener('scroll', window.__headerOverBanner.request);
    window.removeEventListener('resize', window.__headerOverBanner.request);
    window.removeEventListener('load', window.__headerOverBanner.request);
    document.removeEventListener('shopify:section:load', window.__headerOverBanner.request);
  }

  var frame = null;

  function update() {
    frame = null;
    var root = document.documentElement;
    var banner = document.querySelector('[data-behind-header]');
    if (!banner) {
      root.style.removeProperty('--header-solid');
      return;
    }
    var rect = banner.getBoundingClientRect();
    var range = Math.max(rect.height / 3, 1);
    var progress = Math.min(1, Math.max(0, -rect.top / range));
    root.style.setProperty('--header-solid', progress.toFixed(3));
  }

  function request() {
    if (frame === null) frame = window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  window.addEventListener('load', request);
  document.addEventListener('shopify:section:load', request);
  window.__headerOverBanner = { request: request };

  update();
})();
